module.exports = __webpack_public_path__ + "media/mypage/images/arrow-active-4464308b9dcd6732b383a0e46e47116e.png";